import { motion } from "framer-motion";

/**
 * Animated, theme-aware archiving mockup: a bookmark with a saved readable copy
 * that persists even if the original goes offline. Replaces screenshots.
 */

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.14, delayChildren: 0.2 } },
};
const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

const bar = (w) => (
  <span
    style={{
      height: 8,
      borderRadius: 4,
      background: "var(--mock-border)",
      width: w,
      display: "block",
    }}
  />
);

export const ArchivingMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--archiving ${className}`}
      variants={container}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">
          <i className="bi bi-archive me-1" />
          Saved copy
        </div>
      </div>

      <div className="obm-mock__body">
        <motion.div className="obm-mock__item" variants={item}>
          <span className="obm-mock__fav" style={{ background: "#047857" }}>
            A
          </span>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div className="fw-semibold text-truncate">The article you saved</div>
            <div className="small text-secondary text-truncate">
              example.com/great-article
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={item}
          className="mt-3 p-3 rounded-3"
          style={{
            background: "var(--mock-surface)",
            border: "1px solid var(--mock-border)",
          }}
        >
          <div className="d-flex align-items-center justify-content-between mb-3">
            <span className="small fw-semibold">
              <i className="bi bi-file-earmark-text me-1 text-purple" />
              Readable copy
            </span>
            <span className="badge bg-success">
              <i className="bi bi-check-lg me-1" />
              Saved
            </span>
          </div>
          <div className="d-flex flex-column gap-2">
            {bar("90%")}
            {bar("100%")}
            {bar("70%")}
          </div>
        </motion.div>

        <motion.div
          variants={item}
          className="small text-secondary mt-3 d-flex align-items-center"
        >
          <i className="bi bi-shield-check text-success me-2" />
          Kept even if the original goes offline
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ArchivingMock;
